import { render, staticRenderFns } from "./CmgPersonalAndPreferencesPage.vue?vue&type=template&id=601e766a&scoped=true&lang=pug"
import script from "./cmg-personal-and-preferences-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-personal-and-preferences-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPersonalAndPreferencesPage.vue?vue&type=style&index=0&id=601e766a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e766a",
  null
  
)

export default component.exports